const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the Track Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Tracks} Tracks the resource defined to manage Tracks
 * @argument {UserTracks} UserTracks the resource defined to manage UserTracks
 */
app.directive('assessmentHost', ['Application', 'Authorization', 'Assessments', 'UserAssessments', 'AssessmentCharts', '$q', '$translate', function (Application, Authorization, Assessments, UserAssessments, AssessmentCharts, $q, $translate) {
  return {
    restrict: 'E',
    scope: {},
    template: require('../../../templates/directives/assessments/assessment-host.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var routeParameters = Application.navigation.getRouteParameters();
      self.assessmentId = routeParameters.id;
      self.assessment;
      self.csvLink = Application.API + '/learn/v3/assessment-host/user-assessment-csv/' + self.assessmentId + '?authtoken=' + Authorization.getAuthToken().authtoken;
      self.translations = {};

      self.info = {
        activeTab: 'userAssessments',
        activeUserAssessment: null,
        activeAssessmentScore: null,
        rubricQuestions: [],
        activeRubric: null,
        activeQuestionValue: 0,
        showRubric: false,
        showDistribution: false,
        standardChartData: [],
        standardChartLabels: [],
        showStandard: false,
        usersOverlay: {},
        overviewData: {},
        rubricUserData: {},
        rubricChartData: null,
        rubricDistributionData: [],
        rubricDistributionLabels: [],
        toggleRubricChart: function() {
          self.info.showRubric = !self.info.showRubric;
          self.info.showDistribution = !self.info.showDistribution;
        },
        clearScore: function(completed) {
          self.info.activeAssessmentScore = null;
          if (completed) {
            self.scoreReset = true;
          }
        },
        setOverviewData: function(item) {
          if (!item || typeof item !== 'object') {
            return;
          }

          Object.assign(self.info.overviewData, item);
          for (var key in self.info.overviewData) {
            if (key === 'average_score_percent') {
              continue;
            }
            if (self.info.overviewData[key] < 0) {
              self.info.overviewData[key] = 0;
            }
            if (key === 'average_score') {
              self.info.overviewData[key] = self.info.overviewData[key] ? self.info.overviewData[key] : 0;
            }
          }
          var tempTotal = self.info.overviewData.submissions_not_awaiting_manual_grade || 0;
          var tempPassed = self.info.overviewData.participant_passed || 0;

          self.info.overviewData.submission_failures = tempTotal - tempPassed > 0 ? (tempTotal - tempPassed) : 0;
          self.info.overviewData.average_score = self.info.overviewData.average_score || 0;
          self.info.overviewData.average_score_percent = self.info.overviewData.average_score + '%';
        }
      };

      self.standard = {
        init: function () {
          self.info.usersOverlay = {};
          self.info.rubricChartData = null;
          self.info.rubricUserData = {};
          self.info.standardChartData = [];
          self.info.standardChartLabels = [];
          AssessmentCharts.standardData(self.assessmentId)
          .then(function(info) {
            self.info.setOverviewData(info.overview_data);
            self.info.standardChartData = info.data;
            self.info.standardChartLabels = info.labels;
            self.info.showStandard = info.showStandard;
          });
        }
      };

      self.rubric = {
        init: function() {
          self.info.usersOverlay = {};
          self.info.rubricChartData = null;
          self.info.rubricUserData = {};
          self.info.rubricChartData = {};
          self.info.rubricChartData.names = [];
          self.info.rubricChartData.mean_values = [];
          self.info.rubricChartData.rubric_ids = [];
          self.info.rubricDistributionData = [];
          self.info.rubricDistributionLabels = [];
          self.info.activeQuestionValue = 0;

          AssessmentCharts.rubricData(self.assessmentId, self.info.activeRubric, self.info.rubricQuestions)
          .then(function(data) {
            self.info.setOverviewData(data.overview_data);
            self.info.totalAverage = data.totalAverage;
            self.info.rubricUserData = data.rubricUserData;
            self.info.activeQuestionValue = data.activeQuestionValue;
            self.info.rubricChartData.names = data.names;
            self.info.rubricChartData.mean_values = data.mean_values;
            self.info.rubricChartData.rubric_ids = data.rubric_ids;
            self.info.rubricDistributionData = data.data;
            self.info.rubricDistributionLabels = data.labels;
          });
        }
      };

      self.initialize = function() {
        self.assessment = null;
        self.info.overviewData = {};
        if (!self.assessmentId) {
          // error
          return;
        }

        $q.all([
          Assessments.get({subresource: self.assessmentId, fields: 'title,description,video_assessment,file_assessment,questions,number_of_retakes,allow_retake'}).$promise,
          UserAssessments.count({assessment: self.assessmentId}).$promise,
          UserAssessments.count({assessment: self.assessmentId, passed: true}).$promise
        ]).then(function(data) {
          self.info.activeTab = 'userAssessments';
          self.info.activeUserAssessment = null;
          self.info.activeAssessmentScore = null;
          self.info.totalAverage = 0;
          self.info.rubricChartData = null;
          self.info.rubricQuestions = [];
          self.info.activeRubric = null;
          self.info.usersOverlay = {};
          self.assessment = data[0];
          self.info.setOverviewData({participant_count: data[1] && data[1].count ? data[1].count : 0});
          self.info.setOverviewData({participant_passed: data[2] && data[2].count ? data[2].count : 0});
          self.info.showRubric = false;
          self.info.showDistribution = false;
          self.info.showStandard = false;

          if (self.assessment.questions && self.assessment.questions.length) {
            self.assessment.questions.forEach(function(question) {
              if (question.rubric_grading && question.rubric_options && question.rubric_options.length) {
                self.info.rubricQuestions.push(question);
              }
            });
            if (self.info.rubricQuestions.length && self.assessment.video_assessment) {
              self.info.activeRubric = self.info.rubricQuestions[0].id;
              self.info.showRubric = true;
            }
            if (!self.assessment.video_assessment) {
              self.standard.init();
            }
          }

        }).catch(function(error) {
          console.log('assessment find error: ', error);
          // show error
        });
      };

      $scope.$watch('host.info.activeRubric', function(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          self.rubric.init();
        }
      });

      self.initialize();

      $translate([
        'assessmentHost.number_of_participants',
        'assessmentHost.passed_participants',
        'assessmentHost.failed_submissions',
        'assessmentHost.average_score'
      ]).then(function (translations) {
        self.translations = translations;
      });

    }],
    controllerAs: 'host'
  };
}]);

